import React, { Component } from "react";
import { AutoComplete } from "material-ui";
import { validators, validate } from "../../helpers/validationHelpers";

const styles = {
  floatingLabelStyle: {
    color: "#ccc"
  },
  menuStyle: {
    overflow: "auto",
    maxHeight: "350px"
  }
};

class HealthFund extends Component {
  static defaultProps = {
    value: "",
    errorText: "",
    onChange: () => {},
    onBlur: () => {}
  };

  constructor(props) {
    super(props);
    this.state = { searchText: "" };
  }

  componentDidMount = () => {
    if (this.props.value) {
      const selectedOption = this.props.dataSource.find(
        f => f.value === this.props.value
      );
      this.setState({ searchText: selectedOption.text });
    }
  };

  validate = value => {
    const { fieldKey, onError } = this.props;
    const errorMessage = validate(validators[fieldKey], value);
    onError(fieldKey, errorMessage);
  };

  handleBlur = () => {
    this.validate(this.props.value);
  };

  handleChange = e => {
    const value = e.value;
    if (!value) this.setState({ searchText: "" });

    this.validate(value);
    const selectedOption = this.props.dataSource.find(f => f.value === value);
    this.props.onChange(this.props.fieldKey, e.value);
    this.setState({ searchText: selectedOption.text });
  };

  handleUpdateInput = searchText => {
    this.setState({ searchText });
  };

  render() {
    return (
      <AutoComplete
        floatingLabelText="Select your current health fund"
        searchText={this.state.searchText}
        filter={AutoComplete.fuzzyFilter}
        dataSource={this.props.dataSource}
        onNewRequest={this.handleChange}
        onUpdateInput={this.handleUpdateInput}
        openOnFocus
        fullWidth
        floatingLabelStyle={styles.floatingLabelStyle}
        menuStyle={styles.menuStyle}
      />
    );
  }
}

export { HealthFund };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/HealthFund.js